import { render, staticRenderFns } from "./menuSetup.vue?vue&type=template&id=42090d72&scoped=true"
import script from "./menuSetup.vue?vue&type=script&lang=ts"
export * from "./menuSetup.vue?vue&type=script&lang=ts"
import style0 from "./menuSetup.vue?vue&type=style&index=0&id=42090d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42090d72",
  null
  
)

export default component.exports